import { AlarmInfoHeader } from "./AlarmInfoHeader";
export default AlarmInfoHeader;
